import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { exists } from "shared/lib/exists"
import { SelectOption } from "shared/types/Select"
import { Toggle } from "shared/ui/input/boolean/toggle/Toggle"

import { RJSFFormReadonlyField } from "./RJSFFormStringField"
import { RJSFFormFieldProps } from "./types"

export const RJSFFormBooleanField = React.memo(
  (
    props: RJSFFormFieldProps & {
      FieldInformationRenderer?: React.ComponentType<RJSFFormFieldProps>
    }
  ) => {
    const { path, schema, isDisabled, FieldInformationRenderer } = props
    const { t } = useTranslation()

    const options: SelectOption<boolean>[] = useMemo(() => {
      if (exists(schema.default)) {
        return [
          {
            label: schema.default ? t("Boolean.true") : t("Boolean.false"),
            value: schema.default as boolean
          }
        ]
      }
      return []
    }, [schema.options, schema.default])

    if (schema.readOnly) {
      return <RJSFFormReadonlyField {...props} options={options} />
    }

    return (
      <div className="rjsf-form__field-container">
        <div className="rjsf-form__field rjsf-form__field--boolean">
          <Toggle.Root
            name={path}
            label={schema.title ?? ""}
            disabled={isDisabled}
          >
            <div className="rjsf-form__boolean-control">
              <Toggle.Input />
              <Toggle.Label />
            </div>
            <Toggle.ErrorMessage />
          </Toggle.Root>
          {FieldInformationRenderer ? (
            <div className="rjsf-form__field-information">
              <FieldInformationRenderer {...props} />
            </div>
          ) : null}
        </div>
      </div>
    )
  }
)
